module.exports = require("sinon");